module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = (model.parentEntity || {}).entityData || {}\nconst attributes = data.attributes || {}\nconst showTime = attributes.showTime || {}\nlet time = ''\nif(showTime.time) {\nlet nameKey = 'projects.advertisements.fields.time.valueFull'\nif(!showTime.endTS){\nnameKey = 'projects.advertisements.fields.time.value'\n}\ntime = storage.__(nameKey, { time: showTime.time, duration: utils.number.format(showTime.duration, undefined, 'float').formatted })\n}\n%><div><%\n%><%- include('./detailStatusField', { resourceData: { data }}) %><%\n%><%- include('../projects/termViewer', { resourceData: { data }, config: { isAdvertisement: true }}) %><%\n%></div>"
  , __filename = "components/templates/crew/advertisements/detail.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = (model.parentEntity || {}).entityData || {}
const attributes = data.attributes || {}
const showTime = attributes.showTime || {}
let time = ''
if(showTime.time) {
let nameKey = 'projects.advertisements.fields.time.valueFull'
if(!showTime.endTS){
nameKey = 'projects.advertisements.fields.time.value'
}
time = storage.__(nameKey, { time: showTime.time, duration: utils.number.format(showTime.duration, undefined, 'float').formatted })
}

    ; __line = 13
    ; __append("<div>")
    ; 

    ; __line = 14
    ; __append( include('./detailStatusField', { resourceData: { data }}) )
    ; 

    ; __line = 15
    ; __append( include('../projects/termViewer', { resourceData: { data }, config: { isAdvertisement: true }}) )
    ; 

    ; __line = 16
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/advertisements/detail.ejs

}